import './style.css'

const ExpandedComponent = ({ data }) => (
    <article className="expandedComponentWrapper p-2">
        {Object.keys(data)
            ?.slice(2)
            ?.map((ele, idx) => (
                <>
                    {typeof data[ele] != 'object' && (
                        <p
                            key={idx}
                            className={`fw-bold ${
                                idx < Object.keys(data).length - 3 && 'mb-3'
                            }`}
                        >
                            {ele}:{' '}
                            <span className="fw-normal">{data[ele]}</span>
                        </p>
                    )}
                </>
            ))}
    </article>
)

export default ExpandedComponent
